module.exports = __webpack_public_path__ + "static/media/emptyCover.fde4b3a8.svg";